// extracted by mini-css-extract-plugin
module.exports = {"button":"ConnectButton_button__1nK9l","address":"ConnectButton_address__uR0z-"};